export enum StickyTabsCreditRating {
    CONFIDENCE = 'creditrating1',
    RATING = 'creditrating2',
    SAFEST = 'creditrating3'
};
